import Grid from '@material-ui/core/Grid'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import Tooltip from '@material-ui/core/Tooltip'
import AutoComplete from 'Components/AutoComplete'
import EurestoTable from 'Components/EurestoTable'
import Form from 'Components/Form'
import Input from 'Components/Input'
import Modal from 'Components/Modal'
import NavLink from 'Components/NavLink'
import Switch from 'Components/Switch'
import Data from 'EurestoClass/Data'
import User from 'EurestoClass/User'
import EurestoDiv from 'EurestoComponents/EurestoDiv'
import Constants from 'EurestoFonction/Constants'
import Utils from 'EurestoFonction/Utils'
import moment from 'moment'
import React from 'react'
import SplitPane from 'react-split-pane'
import AjoutContact from '../../Page/Ajout'
import DataGrid from '../Table'



moment.locale('fr')

export default class extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      contactModalOpen: false,
      indexContactSelect: -1,
      addNewContact: -1,
      modalKey: Utils.getRandomNumber(),
      relations: props.data,
      relation: props.data && props.data[0] || {},
      index: (props.data || []).length > 0 ? 0 : undefined,
      action: props.action || 'view',
      key: Utils.getRandomNumber(),
      key_grid: Utils.getRandomNumber(),
      datagridId: Utils.getRandomNumber(),
      key_search_contact: Utils.getRandomNumber(),
      position: 0,
      anchorEl: {},
    }
  }

  handleCloseElAction = id => e => {
    //e.preventDefault()
    //e.stopPropagation()
    this.setState({
      position: $('#' + this.state.datagridId + '-body').scrollTop(),
      anchorEl: {
        ...this.state.anchorEl || {},
        [id]: false
      }
    })
  }

  handleClickElAction = (row) => (e) => {
    e.preventDefault()
    e.stopPropagation()
    this.setState({
      position: $('#' + this.state.datagridId + '-body').scrollTop(),
      anchorEl: {
        ...this.state.anchorEl || {},
        [row.id]: true
      }
    })
  }

  onSave = () => {
    let relation = this.state.relation || {}
    let relations = this.state.relations || []
    //relation.actif = 1
    if (this.state.index === undefined) {
      relation.actif = 1
      relations = [relation, ...relations]
    } else {
      relations[this.state.index] = relation
    }
    this.setState({
      relations: relations,
      action: 'view',
      index: this.state.index || 0,
      key: Utils.getRandomNumber(),
      key_grid: Utils.getRandomNumber(),
      position: $('#' + this.state.datagridId + '-body').scrollTop()
    }, this.props.onChange(relations))
  }

  onView = i => action => {
    let relations = this.state.relations || []
    const filter = Object.keys((this.state.relationFilter || {})).filter(f => this.state.relationFilter[f] !== undefined)
    if (filter.length > 0) {
      relations = relations.filter(relation => filter.map(filter => relation[filter] === this.state.relationFilter[filter]).reduce((a, i) => a && i))
    }
    const index = (relations || []).length > 0 ? i || 0 : undefined
    this.setState({
      index: index,
      relation: index >= 0 && relations[index] || {},
      action: 'view',
      position: $('#' + this.props.search + '-body').scrollTop(),
      key: Utils.getRandomNumber()
    }, () => {
      this.props.action === 'add' && this.props.onCancel && this.props.onCancel()
    })
  }

  componentDidUpdate() {
    $('#' + this.state.datagridId + '-body').scrollTop(this.state.position)
  }

  onChange = (data, name) => {
    let relation = this.state.relation || {}
    relation[name] = data
    this.setState({
      relation: relation,
    })
  }

  onDelete = _ => {
    let relations = this.state.relations || []
    relations.splice(this.state.index, 1)
    const index = (this.state.relations || []).length > 0 ? 0 : undefined
    this.setState({
      index: index,
      relations: relations,
      relation: index >= 0 && relations[index] || {},
      action: 'view',
      key: Utils.getRandomNumber(),
      key_grid: Utils.getRandomNumber(),
      position: $('#' + this.props.search + '-body').scrollTop()
    }, this.props.onChange(relations))
  }

  onCancel = _ => {
    this.setState({
      relation: {},
      action: 'add',
      index: undefined,
      key: Utils.getRandomNumber()
    })
  }

  onClickSendEmail = (id, email) => e => {
    e.preventDefault()
    e.stopPropagation()
    const mail = document.createElement('a')
    mail.href = 'mailto:' + email
    document.body.appendChild(mail)
    mail.click()
    mail.remove()
    //window.open(sLink, "emailWindow")
  }

  onCopyClipBoard = (id, text) => e => {
    e.preventDefault()
    e.stopPropagation()
    const textArea = document.createElement('textarea')
    textArea.value = text
    document.body.appendChild(textArea)
    textArea.select()
    document.execCommand('Copy')
    textArea.remove()
  }

  tdEmail = (row) => (
    <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'center'}
      alignItems={'center'} direction={'column'}
      onContextMenu={(e) => this.handleClickElAction(row)(e)}
      className={'anchorElement'}>
      <span>{row.email || ''}</span>
      <span>{row.portable || ''}</span>
      <span>{row.fixe || ''}</span>
    </Grid>
  )

  relation = Data.list(Constants.module.CRM, Constants.donnee.relation)

  form = (disabled, autoFocus) => (
    <Grid key={this.state.key} container style={{ margin: 0 }} spacing={0} justify={'flex-start'}
      alignItems={'stretch'} alignContent={'center'} direction={'column'}>
      <AutoComplete title={EurestoI18n.t('crm:Type relation')}
        disabled={disabled}
        autoComplete={true}
        autoFocus={autoFocus}
        options={this.relation.map(r => ({ label: r.libelle, value: r.id }))}
        name={'relation_id'}
        onChange={this.onChange}
        data={this.state.relation.relation_id} />
      {this.state.relation.contact_id > 0 && disabled &&
        <NavLink className={'EurestoPrimary--text ' + (this.props.disabled && 'cursor-pointer' || 'cursor-not-allowed')}
          to={this.props.disabled && ('/crm/' + this.state.relation.contact_id) || ''}>
          <i className={'fa fa-external-link'} style={{
            paddingRight: 5,
            textAlign: 'left',
          }} />{this.state.relation.contact_libelle}
        </NavLink>
        ||
        !disabled && this.state.relation.relation_id > 0 &&
        <a className="cursor-pointer EurestoPrimary--text" onClick={() => this.searchContact()}>
          <i className={'ei-commun_rechercher'}
            style={{ paddingRight: 5 }} />{this.state.relation.contact_libelle || EurestoI18n.t('crm:Recherche/Ajouter contact')}
        </a>
      }
      <Input title={EurestoI18n.t('crm:Commentaire')}
        name="commentaire"
        disabled={disabled}
        onChange={this.onChange}
        type="text"
        value={this.state.relation.commentaire} />

      {this.props.sellsy &&
        (User.User.get().id === 2 || User.User.get().id === 32820 || User.User.get().id === 1036) &&
        (this.state.relation.entite === 1) &&
        <Switch onChange={this.onChange} name='sellsy_connect'
          disabled={disabled}
          checked={this.state.relation.sellsy_connect}
          label={EurestoI18n.t('crm:Exporter vers sellsy')} />}

      <Grid key={this.state.key + '_update_add_relations'} container style={{ margin: 0, padding: 0 }} spacing={0}
        justify={'flex-start'}
        alignItems={'flex-start'} alignContent={'flex-start'} direction={'column'}>
        <span className={'EurestoSecondary--text'} style={{ textAlign: 'left', fontSize: 11, color: 'lightgreen' }}><i className={'ei-commun_ajouter'} />{this.state.relation.date_creation &&
          (this.state.relation.date_creation && moment(this.state.relation.date_creation).format('DD/MM/YY HH:mm:ss') || '')
          + (this.state.relation.libelle_user_creation && (', ' + this.state.relation.libelle_user_creation) || '')}</span>
        <span className={'EurestoPrimary--text'} style={{ textAlign: 'left', fontSize: 11, color: 'lightblue' }}><i className={'ei-commun_modifier'} />{this.state.relation.contact_date_modification &&
          (this.state.relation.contact_date_modification && moment(this.state.relation.contact_date_modification).format('DD/MM/YY HH:mm:ss') || '')
          + (this.state.relation.libelle_user_modification && (', ' + this.state.relation.libelle_user_modification) || '')}</span>
      </Grid>
    </Grid>
  )

  columns = [
    {
      header: 'id',
      accessor: 'id',
      show: false
    }, {
      header: EurestoI18n.t('crm:Type Relation'),
      headerClassName: 'EurestoPrimary EurestoText--text',
      id: 'relation_id',
      filters: ['search'],
      type: 'string',
      info_tiers: {
        module: Constants.module.CRM,
        donnee: Constants.donnee.relation,
      },
      maxWidth: 150,
      accessor: d => Data.get(Constants.module.CRM, Constants.donnee.relation, { id: d.relation_id }).libelle,
      Cell: row =>
        <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'center'}
          alignItems={'center'} direction={'column'}>
          {Data.get(Constants.module.CRM, Constants.donnee.relation, { id: row.relation_id }).libelle}
          <br />
          <i>{row.commentaire}</i>
        </Grid>
    }, {
      header: EurestoI18n.t('crm:Contact'),
      id: 'contact_libelle',
      filters: ['search'],
      type: 'string',
      sortable: true,
      accessor: 'contact_libelle',
      Cell: row => <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'center'}
        alignItems={'center'} direction={'column'}>
        {row.contact_libelle}
      </Grid>
    }, {
      header: EurestoI18n.t('crm:Coordonnées'),
      id: 'email',
      type: 'string',
      sortable: false,
      accessor: 'email',
      Cell: row => (
        this.state.anchorEl[row.id] && (row.email || row.portable || row.fixe) &&
        <Tooltip disableTouchListener
          interactive
          leaveDelay={200}
          onClose={this.handleCloseElAction(row.id)}
          title={
            <div style={{ margin: 0, padding: 0, fontSize: 15, width: 'auto' }}>
              <List component="nav" dense>
                <React.Fragment>
                  {
                    row.email &&
                    <ListItem onClick={this.onClickSendEmail(row.id, row.email)} button>
                      <Grid container justify={'flex-start'} alignContent={'center'}
                        alignItems={'center'}>
                        <i className={'ei-commun_action_mail'} />&nbsp;<span>Envoyer un email</span>
                      </Grid>
                    </ListItem>
                  }
                  {
                    row.email &&
                    <ListItem onClick={this.onCopyClipBoard(row.id, row.email)} button>
                      <Grid container justify={'flex-start'} alignContent={'center'}
                        alignItems={'center'}>
                        <i className={'fa fa-copy'} />&nbsp;<span>Copier l'adresse email</span>
                      </Grid>
                    </ListItem>
                  }
                  {
                    row.portable &&
                    <ListItem onClick={this.onCopyClipBoard(row.id, row.portable)} button>
                      <Grid container justify={'flex-start'} alignContent={'center'}
                        alignItems={'center'}>
                        <i className={'fa fa-copy'} />&nbsp;<span>Copier le numéro de portable</span>
                      </Grid>
                    </ListItem>
                  }
                  {
                    row.fixe &&
                    <ListItem onClick={this.onCopyClipBoard(row.id, row.fixe)} button>
                      <Grid container justify={'flex-start'} alignContent={'center'}
                        alignItems={'center'}>
                        <i className={'fa fa-copy'} />&nbsp;<span>Copier le numéro de fixe</span>
                      </Grid>
                    </ListItem>
                  }
                </React.Fragment>
              </List>
            </div>
          }>
          {this.tdEmail(row)}
        </Tooltip>
        || this.tdEmail(row)

      )
    }, {
      header: EurestoI18n.t('crm:Modifiée le'),
      id: 'contact_date_modification',
      maxWidth: 80,
      type: 'date',
      accessor: 'contact_date_modification',
      format: 'DD/MM/YY',
    }, {
      header: EurestoI18n.t('crm:#Sellsy'),
      id: 'sellsy_id',
      show: this.props.sellsy && (User.User.get().id === 2 || User.User.get().id === 32820),
      maxWidth: 80,
      type: 'string',
      accessor: 'sellsy_id',
      Cell: row => (
        <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'center'}
          alignItems={'center'}>
          {row.sellsy_id || ''}
        </Grid>
      )
    }
  ]

  render() {
    let relations = this.state.relations

    return (
      <EurestoDiv id={'onglet_contact_relations_contacts'} mainStyle={{ paddingTop: 15 }} title='Relations' expandable expanded={relations && relations.length > 0 || relations === undefined}>
        <SplitPane split={'horizontal'} minSize={240} defaultSize={240} style={{ position: 'relative', overflow: 'visible' }}>
          <Grid container spacing={0}
            style={Object.assign({
              margin: 0,
              padding: 0,
              position: 'relative',
              height: '100%',
            }, this.props.style || {})}
            justify={'center'} alignContent={'flex-start'} alignItems={'flex-start'}>
            <Grid item xs={9} style={{ margin: 0, padding: 0, position: 'relative', height: this.props.maxHeight }}>
              <EurestoTable
                columns={this.columns}
                maxHeight={this.props.maxHeight}
                style={{
                  maxHeight: this.props.maxHeight,
                }}
                styleRow={(row) => !row.actif && { backgroundColor: EurestoColor('EurestoError'), color: EurestoColor("EurestoText") } || {}}
                onClick={(row, index) => this.onView(index)()}
                selectedRowIndex={this.state.index} datas={relations} />
            </Grid>
            <Grid item xs={3} style={{ margin: 0, padding: 0, height: '100%' }}>
              <Form key={this.state.key + '_form'}
                borderLeft
                showTab={false}
                style={{ padding: 0 }}
                onClickUpdate={!this.props.disabled}
                required={{
                  contact_id: { message: '*** Vous devez sélectionner un contact' },
                  relation_id: { message: '*** Vous devez sélectionner un type de relation' }
                }}
                object={this.state.relation}
                action={this.state.action}
                isAllow={{
                  add: !this.props.disabled,
                  update: (relations || []).length > 0 && !this.props.disabled,
                  delete: this.state.index >= 0 && !this.props.disabled
                }}
                onSave={this.onSave}
                onCancel={this.onCancel}
                onDelete={this.onDelete}
                onView={this.onView(this.state.index)}
                libelleAdd={EurestoI18n.t('commun:Nouvelle relation')}
                children={this.form} />
            </Grid>
            {this.ModalContact()}
          </Grid>
        </SplitPane>
      </EurestoDiv>)
  }

  searchContact = _ => {
    this.setState({ contactModalOpen: true, modalKey: Utils.getRandomNumber(), key_search_contact: Utils.getRandomNumber() })
  }

  onCloseModal = () => {
    this.setState({
      contactModalOpen: false,
      indexContactSelect: -1,
      modalKey: Utils.getRandomNumber(),
      addNewContact: -1
    }, () => this.forceUpdate())
  }

  handleSelectContact = (row) => {
    let relation = this.state.relation
    relation['contact_id'] = row.id
    relation['contact_libelle'] = row.libelle
    relation['entite'] = row.entite
    relation['email'] = row.email
    relation['portable'] = row.portable
    relation['fixe'] = row.fixe
    relation['date_modification'] = row.date_modification
    relation['libelle_user_creation'] = User.User.get().libelle
    this.setState({
      contactModalOpen: false,
      modalKey: Utils.getRandomNumber(),
      addNewContact: -1,
      relation: relation
    })
  }

  addContact = () => {
    const searchContact = ('client_' + (this.state.key_search_contact || '') + User.Entite.get().id)
    console.log("searchName", searchContact)
    const contact = localStorage.getItem('search_' + searchContact) && JSON.parse(localStorage.getItem('search_' + searchContact)) || {}
    console.log("searchContact", contact)
    this.setState({
      searchContact: contact,
      modalKey: Utils.getRandomNumber(),
      addNewContact: 1
    }, () => this.forceUpdate())
  }

  ModalContact = () => {
    return (
      <Modal key={this.state.modalKey} open={this.state.contactModalOpen} onClose={this.onCloseModal} grid={{ xs: 10 }}>
        <EurestoDiv
          fromModal={true} title={(this.props.clientName && (this.props.clientName + ' - ') || '') + (
            this.state.addNewContact === -1 && EurestoI18n.t('crm:Nouvelle relation') || EurestoI18n.t('crm:Nouveau contact')) + ' (' + (Data.get(Constants.module.CRM, Constants.donnee.relation, {
              id: this.state.relation.relation_id
            }) || {}).libelle + ')'} buttonsLeft={this.state.addNewContact === -1 && [
              {
                title: 'Ajouter',
                icon: ' ei-commun_ajouter',
                cb: this.addContact
              }
            ]} buttonsRight={[{
              icon: ' ei-commun_fermer',
              className: 'EurestoError--text EurestoText',
              cb: this.onCloseModal
            }
            ]} style={{
              margin: 0,
              padding: 0,
              maxHeight: User.CalculHeight.getHeightWanted(15),
              height: User.CalculHeight.getHeightWanted(15),
              overflowY: 'auto'
            }}>
          {this.state.addNewContact === -1 &&
            <DataGrid onClick={this.handleSelectContact} defaultSearch={{ '?actif': 1 }} type="client" view={'list'}
              name={this.state.key_search_contact} unsave={false}
              showSearch={true} /> ||
            <AjoutContact contact={this.state.searchContact} modalHeight={50} handleSaveContact={this.handleSelectContact} handleCancelContact={() => this.onCloseModal() || true} />}
        </EurestoDiv>
      </Modal>)
  }
}



// WEBPACK FOOTER //
// ./app/App/Module/CRM/Component/Relation/index.js